const emptyState = {
  show: false,
  fab: [],
  content: null
};

export const sliderDialogReducer = (state = emptyState, { type, payload }) => {
  switch (type) {
    case 'OPEN_SLIDER_DIALOG':
      window.history.pushState(null, null, window.location.pathname);
      document.body.style.overflowY = 'hidden';
      // document.body.style.paddingRight = '15px'
      return {
        ...state,
        show: true
      };

    case 'CLOSE_SLIDER_DIALOG':
      document.body.style.overflowY = 'revert';
      // document.body.style.paddingRight = '0'
      return emptyState;

    case 'ADD_CONTENT':
      return {
        ...state,
        content: payload
      };

    case 'ADD_FAB':
      return {
        ...state,
        fab: payload
      };

    default:
      return state;
  }
};
